export default __webpack_public_path__ + "static/media/IC00041-picture_edit.d4162b74.svg";